// extracted by css-extract-rspack-plugin
export default {"root":"root-dDmM3K","text":"text-JC1083","pic":"pic-vdi8TM","picTop":"picTop-XM7Tpf","upgrade":"upgrade-HQv5Ms"};